"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initPageExplorerStore = void 0;
var redux_1 = require("redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
// import { perfMiddleware } from '../../utils/performance';
var PageExplorer_1 = __importDefault(require("./PageExplorer"));
var explorer_1 = __importDefault(require("./reducers/explorer"));
var nodes_1 = __importDefault(require("./reducers/nodes"));
var initPageExplorerStore = function () {
    var rootReducer = redux_1.combineReducers({
        explorer: explorer_1["default"],
        nodes: nodes_1["default"],
    });
    var middleware = [
        redux_thunk_1["default"],
    ];
    // Uncomment this to use performance measurements.
    // if (process.env.NODE_ENV !== 'production') {
    //   middleware.push(perfMiddleware);
    // }
    return redux_1.createStore(rootReducer, {}, redux_1.compose(redux_1.applyMiddleware.apply(void 0, __spreadArray([], __read(middleware))), 
    // Expose store to Redux DevTools extension.
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (func) { return func; }));
};
exports.initPageExplorerStore = initPageExplorerStore;
exports["default"] = PageExplorer_1["default"];
